var _path, _path2, _path3, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGlobeWithPin = function SvgGlobeWithPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.024 11.464h8.51M5.604 7.2h12.794M4.929 15.729h6.54M13.928 4.236a12.108 12.108 0 0 1 1.641 5.098M10.075 19.76c-1.082-1.587-1.805-4.47-1.805-7.763 0-3.292.723-6.174 1.805-7.761",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 19.838a8 8 0 1 1 6.231-9.467",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 11.52a3.2 3.2 0 0 1 3.2 3.2c0 1.364-1.912 3.965-2.78 5.075a.534.534 0 0 1-.84 0c-.869-1.111-2.78-3.71-2.78-5.076a3.2 3.2 0 0 1 3.2-3.2Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.794,
    cy: 14.715,
    r: 1.015,
    fill: "currentColor"
  })));
};

export default SvgGlobeWithPin;